import React from 'react'
import Calendar from "./calendar.svg"

function CalendarIcon() {
    return <img src={Calendar} alt="Calendar Icon" />;
}

export default CalendarIcon